export const FEATURE_FLAG_REGIME_DRAFT_LOCKING = "regime-draft-locking"
